import { Button, ButtonGroup } from '@material-ui/core';
import * as React from 'react';
import LexiconLanguage from "../new/lexicons/LexiconLanguage";
import './LexiconLanguageSelect.css';

interface Props {
    currentLanguage: LexiconLanguage;
    onSelect: (language: LexiconLanguage) => void;
}

export default class LexiconLanguageSelect extends React.Component<Props> {

    public constructor(props: Props) {
        super(props);
        this.onHebrewClick = this.onHebrewClick.bind(this);
        this.onGreekClick = this.onGreekClick.bind(this);
    }

    public render() {
        return (
            <div className="LexiconLanguageSelect">
                <ButtonGroup color="secondary" size="small" fullWidth={true} disableRipple={true}>
                    <Button disableRipple={true} variant={this.props.currentLanguage === LexiconLanguage.Hebrew ? 'contained' : undefined} onClick={this.onHebrewClick}>Hebrew</Button>
                    <Button disableRipple={true} variant={this.props.currentLanguage === LexiconLanguage.Greek ? 'contained' : undefined} onClick={this.onGreekClick}>Greek</Button>
                </ButtonGroup>
            </div>
        );
    }

    private onHebrewClick() {
        this.props.onSelect(LexiconLanguage.Hebrew);
    }

    private onGreekClick() {
        this.props.onSelect(LexiconLanguage.Greek);
    }
}
